"use strict";

import $ from 'jquery'
import { getConfig } from '../config-utils'

export default function ($scope) {
    let _config = getConfig('_config');

    if(!$scope) {
        $scope = $('body');
    }

    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( _config['_preload'][_key] && appRaffle.modules[_key] && typeof appRaffle.modules[_key] === 'function' ){
                appRaffle.modules[_key]($scope);
            }
        });
    }

    //init all modules if the right _config key is set for them
    for (let module in _config) {
        if (_config[module] && appRaffle.modules[module] && typeof  appRaffle.modules[module] === 'function') {
            appRaffle.modules[module]($scope);
        }
    }

    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( _config['_reload'][_key] && appRaffle.modules[_key] && typeof appRaffle.modules[_key] === 'function' ){
                appRaffle.modules[_key]($scope);
            }
        });
    }
}
